import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';
import * as THREE from 'three';

export function getScreenPosition(position: THREE.Vector3): {
  x: number;
  y: number;
} {
  const vector = new THREE.Vector3(position.x, position.y, position.z);
  vector.project(globalStores.editorStateStore.sceneInfo.scene2d.camera);
  const rect = globalStores.editorStateStore.sceneInfo.canvasElement.getBoundingClientRect();
  const widthHalf = rect.width / 2;
  const heightHalf = rect.height / 2;

  return {
    x: vector.x * widthHalf + widthHalf + rect.left,
    y: -(vector.y * heightHalf) + heightHalf + rect.top
  };
}

export function getEntityCenter(entityInfo: { entityId: string; type: EEntityType }) {
  if (entityInfo.type === EEntityType.Furniture) {
    const furnitureData = globalStores.modelStore.getFurnitureData(entityInfo.entityId);
    if (furnitureData) {
      return furnitureData.center;
    }
  } else if (entityInfo.type === EEntityType.Column) {
    const columnData = globalStores.structStore.getColumnData(entityInfo.entityId);
    if (columnData) {
      return columnData.center;
    }
  } else if (entityInfo.type === EEntityType.DoorWindow) {
    const windowData = globalStores.modelStore.getWindowData(entityInfo.entityId);
    if (windowData) {
      return windowData.center;
    }
  } else if (entityInfo.type === EEntityType.ModelGroup) {
    const modelGroupData = globalStores.modelGroupStore.getModelGroupData(entityInfo.entityId);
    if (modelGroupData) {
      return modelGroupData.center;
    }
  } else if (entityInfo.type === EEntityType.Assembly) {
    const modelGroupData = globalStores.assemblyStore.getAssemblyData(entityInfo.entityId);
    if (modelGroupData) {
      return modelGroupData.center;
    }
  }

  return;
}
